// US metering route map.
//
//   /metering            Meter directory (tenant-wide list; any reader role)
//   /metering/:esiId     Meter detail (summary + consumption + reads/vee/lifecycle)
//   /ops/metering        Metering Ops Console (ESI lookup; ops/admin only)
//
// The list + detail read via endpoints the BE opens to `view-only`, so they are
// broadly readable. The ESI-lookup Ops console stays role-guarded inline
// (same convention as /ops/enrollment-issues).

import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const OpsMeteringPage = lazy(() =>
  import('./pages/OpsMeteringPage').then((m) => ({ default: m.OpsMeteringPage })),
);
const MetersListPage = lazy(() =>
  import('./pages/MetersListPage').then((m) => ({ default: m.MetersListPage })),
);
const MeterDetailPage = lazy(() =>
  import('./pages/MeterDetailPage').then((m) => ({ default: m.MeterDetailPage })),
);

export const meteringRoutes: RouteObject[] = [
  { path: '/metering', element: <MetersListPage /> },
  { path: '/metering/:esiId', element: <MeterDetailPage /> },
  { path: '/ops/metering', element: <OpsMeteringPage /> },
];
